require('./CCComponent');
require('./CCComponentInSG');

module.exports = [
    require('./CCSprite'),
    require('./CCWidget'),
    require('./CCCanvas'),
    require('./CCAudioSource'),
    require('./CCAnimation'),
    require('./CCButton'),
    require('./CCLabel'),
    require('./CCProgressBar'),
    require('./CCMask'),
    require('./CCScrollBar'),
    require('./CCScrollView'),
    require('./CCLayout'),
];
